(() => {
  function initialize() {
    document.querySelectorAll('[data-photo-first-reviews]').forEach(root => {
      if (root.dataset.reviewReady) return;
      root.dataset.reviewReady = 'true';
      const clean = root.dataset.reviewStyle === 'clean';
      const french = (root.dataset.locale || document.documentElement?.lang || '').startsWith('fr');
      const localeRoot = window.Shopify?.routes?.root || '/';
      const modelName = href => {
        const handle = (href || '').split('/products/')[1]?.split(/[?#]/)[0] || '';
        const titan = handle.match(/boot-rack-(\d+)-wide.*titan/);
        if (titan) return `Titan ${titan[1]}${french ? ' po' : '″'}`;
        const known = [['signature','Signature'],['zeus','Zeus'],['moderno','Moderno'],['noble','Noble'],['locker','Locker'],['plastico','Plastico'],['plastic-boot-rack','Plastico']].find(([key]) => handle.includes(key));
        return known ? known[1] : 'Rakabot';
      };
      const reveal = () => root.removeAttribute('data-reviews-pending');
      if (clean) setTimeout(reveal, 6000);
      root.closest('.gh-wrap')?.addEventListener('click', event => {
        const step = event.target.closest('[data-review-step]');
        const track = root.querySelector('.jdgm-all-reviews__body');
        if (!step || !track) return;
        track.scrollBy({left: Number(step.dataset.reviewStep) * track.clientWidth * .9, behavior: 'smooth'});
      });
      let frame, currentTrack;
      const observed = new WeakSet();
      const resize = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(schedule);
      function measure() {
        const track = root.querySelector('.jdgm-all-reviews__body');
        if (!track) return;
        if (track !== currentTrack) {
          currentTrack = track;
          track.addEventListener('scroll', schedule, {passive:true});
        }
        const cards = [...track.children].filter(card => card.classList.contains('jdgm-rev'));
        for (const card of cards) {
          if (!observed.has(card)) { resize?.observe(card); observed.add(card); }
          const pictures = card.querySelector?.('.jdgm-rev__pics');
          if (pictures && pictures !== card.firstElementChild) card.prepend(pictures);
          const photo = clean && card.querySelector?.('.jdgm-rev__pics img');
          const full = photo && photo.closest('a')?.href;
          if (full && !photo.dataset.sharp) {
            const sharp = full.replace(/width=\d+/, 'width=640');
            photo.dataset.sharp = 'true';
            photo.removeAttribute('srcset');
            photo.dataset.src = sharp;
            photo.src = sharp;
          }
          const product = card.querySelector?.('.jdgm-rev__prod-link');
          if (product && !product.dataset.modelName) {
            product.dataset.modelName = modelName(product.getAttribute('href'));
            product.textContent = product.dataset.modelName;
            const link = new URL(product.href, location.href);
            if (link.origin === location.origin && link.pathname.startsWith('/products/') && localeRoot !== '/') {
              link.pathname = localeRoot.replace(/\/$/, '') + link.pathname;
              product.href = link.pathname + link.search + link.hash;
            }
          }
          const body = card.querySelector?.('.jdgm-rev__body');
          if (body && body.textContent.length > (clean ? 170 : 260) && !body.hasAttribute('data-review-excerpt')) {
            body.setAttribute('data-review-excerpt', '');
            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'gl-review-expand';
            toggle.textContent = root.dataset.readMore;
            toggle.setAttribute('aria-expanded', 'false');
            toggle.addEventListener('click', () => {
              const expanded = body.classList.toggle('is-expanded');
              toggle.textContent = expanded ? root.dataset.readLess : root.dataset.readMore;
              toggle.setAttribute('aria-expanded', String(expanded));
              schedule();
            });
            body.after(toggle);
          }
        }
        if (clean && root.hasAttribute('data-reviews-pending') && root.dataset.photoSortReady && cards[0]?.querySelector('.jdgm-rev__pics img')) reveal();
        const rect = track.getBoundingClientRect();
        if (rect.width <= 0) return;
        const visible = cards.filter(card => {
          const box = card.getBoundingClientRect();
          return Math.min(box.right,rect.right) - Math.max(box.left,rect.left) > Math.min(box.width,rect.width) * .5;
        });
        if (visible.length) {
          const height = Math.ceil(Math.max(...visible.map(card => card.getBoundingClientRect().height))) + 20;
          track.style.setProperty('--review-track-height', height + 'px');
          track.setAttribute('data-auto-height','');
        }
      }
      function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); }
      function sync() {
        const sort = root.querySelector('.jdgm--done-setup-widget .jdgm-sort-dropdown');
        const judgeme = window.jdgm;
        if (!root.dataset.photoSortReady && sort?.querySelector('option[value="pictures-first"]') && typeof judgeme?.scrollTo === 'function') {
          root.dataset.photoSortReady = 'true';
          if (sort.value !== 'pictures-first') {
            sort.value = 'pictures-first';
            const scrollTo = judgeme.scrollTo;
            judgeme.scrollTo = function(target, ...args) {
              if (root.contains(target?.[0] || target)) return;
              return scrollTo.call(this, target, ...args);
            };
            try {
              sort.dispatchEvent(new Event('change',{bubbles:true}));
            } finally {
              judgeme.scrollTo = scrollTo;
            }
          }
        }
        schedule();
      }
      const mutation = new MutationObserver(sync);
      mutation.observe(root,{childList:true,subtree:true});
      root.addEventListener('load',schedule,true);
      root.addEventListener('change',schedule);
      window.addEventListener('resize',schedule,{passive:true});
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{
        mutation.disconnect(); resize?.disconnect(); cancelAnimationFrame(frame);
        window.removeEventListener('resize',schedule);
      },{once:true});
      sync();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
